var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"changelog-container"},[_c('v-container',{staticClass:"form-content overflow-auto pa-5",attrs:{"fluid":""}},[_c('h4',[_vm._v("TODO")])]),_c('div',{staticClass:"kontakt-content pa-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }